import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets(CSS 重置的现代替代方案)

//引入 ElementUI插件
import ElementUI from 'element-ui'
//引入 ElementUI的样式
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
//引入v-charts 图形列表库
import VCharts from 'v-charts'

//引入全局的样式
import '@/styles/index.scss' // global css

import App from './App'

//引入路由插件
import router from './router'
//引入vuex仓库插件
import store from './store'

//@指的是src目录
import '@/icons' // icon
import '@/permission' // permission control

//导出json数据的excel
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

Vue.use(ElementUI, { locale })
Vue.use(VCharts)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js